module.exports = __webpack_public_path__ + "img/odwh2_v2_element_06.ad574e72.png";